<template>
  <div>
    <b-tabs>
      <b-tab title="Case List" active>
        <cases-tab :companyId="companyId" />
      </b-tab>
      <b-tab title="Network">
        <network-tab :companyId="companyId" />
      </b-tab>
      <b-tab title="Invoices">
        <b-card-text>Tab Contents 2</b-card-text>
      </b-tab>
      <b-tab title="Payments">
        <b-card-text>Tab Contents 2</b-card-text>
      </b-tab>
       <b-tab title="Distributions">
        <b-card-text>Distributions content</b-card-text>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import CasesTab from './Cases';
import NetworkTab from './Network';

export default {
  name: 'CompanyDetailsTab',
  components: {
    CasesTab,
    NetworkTab
  },
  props: ['companyId'],
  computed: {
    ...mapGetters('companies', ['companyById']),
    ...mapState('companies', ['company']),

     isNotesValid(){
       return (
         this.company.notes===null|| 
         this.company.notes.match(/^ *$/) !== null
         );
     }
    // company() {
    //   return this.companyById(this.companyId);
    // },
  },
  methods:{
    ...mapActions('companies', ['saveCompanyNotes']),
  },
  mounted() {}
};
</script>